/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_D1dInputs */

const en_mk_sol_konsultan_d1d = /** @type {(inputs: Mk_Sol_Konsultan_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The engagement is split into stages with dependencies, so it is visible what waits on what.`)
};

const id_mk_sol_konsultan_d1d = /** @type {(inputs: Mk_Sol_Konsultan_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyek dipecah jadi tahap dengan dependensi, jadi terlihat mana yang menunggu apa.`)
};

/**
* | output |
* | --- |
* | "The engagement is split into stages with dependencies, so it is visible what waits on what." |
*
* @param {Mk_Sol_Konsultan_D1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_d1d = /** @type {((inputs?: Mk_Sol_Konsultan_D1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_D1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_d1d(inputs)
	return en_mk_sol_konsultan_d1d(inputs)
});